import h2h from './h2h.jst';
import open from './open.jst';

export default {
	h2h,
	open
};